import React from 'react'
import SubBenifits from './subCmponents/subBenifits'

export default function Choose() {
  return (
   <div id="benifits">
  <div className="inner">
    <h1>Why Clients Choose Tooliso</h1>
    <p style={{alignSelf:"center",padding:"10px"}}>And never look back</p>
    <div className="lightning">
      <SubBenifits 
        heading="100% Custom-Built, No Templates" 
        comment="Every solution is crafted from scratch to perfectly fit your business needs" 
        image="Code"
        emoji="✅"
      />
      <SubBenifits 
        heading="Business-Savvy Engineers" 
        comment="We think beyond code to deliver real ROI and competitive advantage" 
        image="TrendingUp"
        emoji="✅"
      />
      <SubBenifits 
        heading="Speed-to-Market" 
        comment="Rapid deployment without compromising on quality or scalability" 
        image="Zap"
        emoji="✅"
      />
      <SubBenifits 
        heading="Battle-Tested Experience" 
        comment="Proven in high-stakes environments from startups to enterprises" 
        image="Shield"
        emoji="✅"
      />
      <SubBenifits 
        heading="Clear Communication" 
        comment="No tech jargon - just transparent progress updates and deliverables" 
        image="MessageCircle"
        emoji="✅"
      />
    </div>
  </div>
</div>
  )
}
